import * as actionTypes from "../../constants/ActionTypes/AdminPortal/UserActivityLogs";

export const logUserSessionActivities = (userActivity, description) => ({
    type: actionTypes.ADMINISTRATOR_USER_SESSION_LOGS_INIT,
    userActivity,
    description
})